import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import PrivateRoute from './PrivateRoute';
import LoadingSpinner from '../components/LoadingSpinner';

const Login = React.lazy(() => import('../pages/Admin/Login'));
const AdminDashboard = React.lazy(() => import('../pages/Admin/Dashboard'));
const ContactosAdmin = React.lazy(() => import('../pages/Admin/Contactos'));
const ViagensAdmin = React.lazy(() => import('../pages/Admin/Viagens'));
const ViagemAdmin = React.lazy(() => import('../pages/Admin/Viagens/Viagem'));
const CategoriesAdmin = React.lazy(() => import('../pages/Admin/Categories'));
const TeamMembersAdmin = React.lazy(() => import('../pages/Admin/TeamMembers'));
const CarrosselAdmin = React.lazy(() => import('../pages/Admin/Carrossel'));
const HeroAdmin = React.lazy(() => import('../pages/Admin/Hero'));
const MetadadosAdmin = React.lazy(() => import('../pages/Admin/Metadados'));
const ContentAdmin = React.lazy(() => import('../pages/Admin/Content'));
const AboutGalleryManager = React.lazy(() => import('../pages/Admin/AboutGalleryManager'));
const FAQAdmin = React.lazy(() => import('../pages/Admin/FAQ'));
const FaviconAdmin = React.lazy(() => import('../pages/Admin/Favicon'));
const TestimonialsAdmin = React.lazy(() => import('../pages/Admin/Testimonials'));
const AboutSystemAdmin = React.lazy(() => import('../pages/Admin/AboutSystem'));
const GuiaSiteAdmin = React.lazy(() => import('../pages/Admin/GuiaSite'));
const RecomendacoesAdmin = React.lazy(() => import('../pages/Admin/Recomendacoes'));
const ContaAdmin = React.lazy(() => import('../pages/Admin/Conta'));
const DesignSystemPage = React.lazy(() => import('../pages/Design'));
const AnalyticsAdmin = React.lazy(() => import('../pages/Admin/Analytics'));
const DestaquesConfigAdmin = React.lazy(() => import('../pages/Admin/DestaquesConfig'));
const LegalPagesAdmin = React.lazy(() => import('../pages/Admin/LegalPages'));

const AdminRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="login" element={<Login />} />

        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AdminLayout>
                <Suspense fallback={<LoadingSpinner />}>
                  <Routes>
                    <Route index element={<Navigate to="dashboard" replace />} />
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="contactos" element={<ContactosAdmin />} />
                    <Route path="analytics" element={<AnalyticsAdmin />} />
                    <Route path="viagens" element={<ViagensAdmin />} />
                    <Route path="viagens/nova" element={<ViagemAdmin />} />
                    <Route path="viagens/:id/editar" element={<ViagemAdmin />} />
                    <Route path="categories" element={<CategoriesAdmin />} />
                    <Route path="teammembers" element={<TeamMembersAdmin />} />
                    <Route path="carrossel" element={<CarrosselAdmin />} />
                    <Route path="hero" element={<HeroAdmin />} />
                    <Route path="destaque" element={<DestaquesConfigAdmin />} />
                    <Route path="metadados" element={<MetadadosAdmin />} />
                    <Route path="informacao-legal" element={<LegalPagesAdmin />} />
                    <Route path="content" element={<ContentAdmin />} />
                    <Route path="about-gallery" element={<AboutGalleryManager />} />
                    <Route path="faq" element={<FAQAdmin />} />
                    <Route path="favicon" element={<FaviconAdmin />} />
                    <Route path="testimonials" element={<TestimonialsAdmin />} />
                    <Route path="sobre-o-sistema" element={<AboutSystemAdmin />} />
                    <Route path="guia" element={<GuiaSiteAdmin />} />
                    <Route path="recomendacoes" element={<RecomendacoesAdmin />} />
                    <Route path="conta" element={<ContaAdmin />} />
                    <Route path="design" element={<DesignSystemPage />} />
                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                  </Routes>
                </Suspense>
              </AdminLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AdminRoutes;
